/** Metadata catalog and honest collection projection; no provider dispatch. */
import * as z from 'zod'
import { storeProjectSourcesSchema, type ProjectSourceStatus } from '@testfeed/integration-contracts'
const connection = z
  .object({ id: z.string(), status: z.string(), externalAccountLabel: z.string(), externalAccountId: z.string() })
  .passthrough()
export const integrationsPayloadSchema = z.object({
  capabilities: z.array(z.string()).optional(),
  organizationId: z.string().optional(),
  storeConnectionId: z.string().optional(),
  testFeedIntegrationsUrl: z.string(),
  providers: z.array(
    z.object({
      id: z.string(),
      label: z.string(),
      description: z.string(),
      availability: z.enum(['enabled', 'coming_soon']),
      connection: connection.nullable(),
    }),
  ),
  projectSources: storeProjectSourcesSchema.optional(),
})
export type IntegrationProviderSummary = z.infer<typeof integrationsPayloadSchema>['providers'][number]
export const integrationVotesSchema = z.object({
  votes: z.array(
    z.object({
      organizationId: z.string(),
      provider: z.string(),
      voted: z.boolean(),
      updatedAt: z.string().nullable(),
    }),
  ),
})
export function isCollectionPending(status: ProjectSourceStatus) {
  const pending =
    status.coverage === 'collecting' ||
    (status.collection?.activeRuns ?? 0) > 0 ||
    (status.collection?.publicationPending ?? 0) > 0
  return (
    status.coverage !== 'paused' &&
    pending &&
    !status.latestFailure &&
    (status.collection?.unresolvedReports ?? 0) === 0
  )
}
export function shouldPollIntegration(input: { visible: boolean; failed: boolean; pending: boolean; elapsed: number }) {
  return input.visible && !input.failed && input.pending && input.elapsed < 600_000
}
export function collectionLabel(status: ProjectSourceStatus) {
  if (status.coverage === 'paused') return 'paused' as const
  if (status.coverage === 'not_started') return 'notStarted' as const
  if (status.latestFailure || (status.collection?.unresolvedReports ?? 0) > 0) return 'needsAttention' as const
  if (isCollectionPending(status)) return 'collecting' as const
  return 'complete' as const
}
